export default __webpack_public_path__ + "static/media/1006.23d42349.png";